/**
 * The arithmetic behind dragging the cut line (ItemPoolEditor). Kept apart
 * from the component so it can be tested without a browser.
 */

/** A row's box as the pointer sees it. */
export interface RowBox {
  top: number;
  height: number;
}

/** A row's place in the list, as laid out. */
export interface RowOffset {
  offsetTop: number;
  offsetHeight: number;
}

/**
 * The position the line lands on for a pointer at `clientY`: the number of
 * rows whose middle is above the pointer. 0 = above the first row;
 * rows.length = below the last.
 */
export function slotForPointer(clientY: number, rows: RowBox[]): number {
  return rows.filter((r) => clientY > r.top + r.height / 2).length;
}

/** Where to draw the following line for `slot`, relative to the list. */
export function indicatorTopForSlot(slot: number, rows: RowOffset[]): number {
  if (rows.length === 0) return 0;
  if (slot < rows.length) return rows[Math.max(0, slot)].offsetTop;
  const last = rows[rows.length - 1];
  return last.offsetTop + last.offsetHeight;
}
